import React from 'react';
import { ShieldIcon, CheckIcon, InfoIcon } from 'lucide-react';
interface ProductSectionProps {
  profile: {
    profile: string;
    title: string;
    description: string;
    recommendations: string[];
  };
}
const ProductSection: React.FC<ProductSectionProps> = ({
  profile
}) => {
  return <section id="product" className="w-full py-16 px-4 bg-gray-900" data-id="element-152">
      <div className="max-w-5xl mx-auto" data-id="element-153">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-154">
          Revolutionera ditt sexliv med VeeloBooster
        </h2>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-155">
          <div className="flex-1" data-id="element-156">
            <div className="bg-[#0A1020] rounded-xl p-6 h-full" data-id="element-157">
              <h3 className="text-xl font-semibold mb-4" data-id="element-158">
                Anpassad för din profil: {profile.title}
              </h3>
              {profile.profile === 'erection' && <div className="space-y-4" data-id="element-159">
                  <p data-id="element-160">
                    VeeloBooster ökar blodflödet till corpora cavernosa, vilket
                    ger kraftigare och mer långvariga erektioner.
                  </p>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-161">
                    <h4 className="font-medium mb-2" data-id="element-162">
                      Epimedium Icariin (Horny Goat Weed)
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-163">
                      Extraherad från en exotisk frukt hemmahörande i Amazonas.
                      Denna frukt har studerats av Brasiliens jordbruksmyndighet
                      och har visat sig innehålla ämnen som har starka effekter
                      på blodcirkulationen och testosteronnivåerna i kroppen.
                    </p>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-164">
                      Resultat: Kraftfulla erektioner och underlättad tillväxt i
                      penisvävnaden.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'libido' && <div className="space-y-4" data-id="element-165">
                  <p data-id="element-166">
                    VeeloBooster ökar koncentrationen av hormonet testosteron
                    som är ansvarigt för den manliga sexdriften.
                  </p>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-167">
                    <h4 className="font-medium mb-2" data-id="element-168">
                      Eurycoma longifolia (Longjack)
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-169">
                      Även känd som Tongkat Ali har länge använts för behandling
                      av åldersrelaterade sexuella störningar, symptom av
                      andropaus och för att stimulera det manliga libidot.
                    </p>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-170">
                      Resultat: Ökad sexlust och förbättrad sexuell
                      prestationsförmåga.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'energy' && <div className="space-y-4" data-id="element-171">
                  <p data-id="element-172">
                    VeeloBooster är rik på ämnen som ger dig extra energi så att
                    du kan njuta av din nya kraft och virilitet hela natten.
                  </p>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-173">
                    <h4 className="font-medium mb-2" data-id="element-174">Serenoa Repens</h4>
                    <p className="text-sm text-gray-300" data-id="element-175">
                      Serenoa Repens används för att höja testosteronnivån,
                      vilket ger ökad energi och sexuell aptit så att du kan
                      fortsätta natten igenom.
                    </p>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-176">
                      Resultat: Mer uthållighet och energi för längre sexuella
                      aktiviteter.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'balance' || profile.profile === 'medical' && <div className="space-y-4" data-id="element-177">
                    <p data-id="element-178">
                      VeeloBooster arbetar på fyra fronter för att avgöra
                      kvaliteten i ditt sex och kraften hos dina erektioner.
                    </p>
                    <div className="p-4 bg-gray-800 rounded-lg" data-id="element-179">
                      <h4 className="font-medium mb-2" data-id="element-180">Nässelrot</h4>
                      <p className="text-sm text-gray-300" data-id="element-181">
                        En mild men effektiv aromatas-blockerare som
                        kontrollerar östrogen och främjar högre
                        testosteronnivåer och får nivåerna av DHT att öka.
                      </p>
                      <p className="text-xs text-gray-400 mt-2" data-id="element-182">
                        Resultat: Balanserad hormonprofil för optimal sexuell
                        hälsa.
                      </p>
                    </div>
                  </div>}
            </div>
          </div>
          <div className="flex-1" data-id="element-183">
            <div className="bg-[#0A1020] rounded-xl p-6 h-full" data-id="element-184">
              <div className="flex justify-between items-start mb-6" data-id="element-185">
                <h3 className="text-xl font-semibold" data-id="element-186">VeeloBooster</h3>
                <div className="p-2 bg-[#10C96C] bg-opacity-20 rounded-md" data-id="element-187">
                  <span className="text-[#10C96C] text-sm font-medium" data-id="element-188">
                    Rekommenderad
                  </span>
                </div>
              </div>
              <div className="aspect-w-1 aspect-h-1 mb-6" data-id="element-189">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2sac16cyRSoitJuXJ38uPn/525665f3-2415-443f-a397-77c2af10b8f4.png" alt="VeeloBooster produkt" className="w-full h-auto object-contain rounded-lg" data-id="element-190" />
              </div>
              <div className="space-y-4 mb-6" data-id="element-191">
                <div className="flex items-start" data-id="element-192">
                  <div className="mr-3 mt-1" data-id="element-193">
                    <CheckIcon className="w-4 h-4 text-[#10C96C]" data-id="element-194" />
                  </div>
                  <p className="text-sm" data-id="element-195">
                    Förbättrad blodcirkulation för kraftigare erektioner
                  </p>
                </div>
                <div className="flex items-start" data-id="element-196">
                  <div className="mr-3 mt-1" data-id="element-197">
                    <CheckIcon className="w-4 h-4 text-[#10C96C]" data-id="element-198" />
                  </div>
                  <p className="text-sm" data-id="element-199">
                    Ökad testosteronproduktion för högre sexlust
                  </p>
                </div>
                <div className="flex items-start" data-id="element-200">
                  <div className="mr-3 mt-1" data-id="element-201">
                    <CheckIcon className="w-4 h-4 text-[#10C96C]" data-id="element-202" />
                  </div>
                  <p className="text-sm" data-id="element-203">
                    Cellregenerering för maximal expansion
                  </p>
                </div>
                <div className="flex items-start" data-id="element-204">
                  <div className="mr-3 mt-1" data-id="element-205">
                    <CheckIcon className="w-4 h-4 text-[#10C96C]" data-id="element-206" />
                  </div>
                  <p className="text-sm" data-id="element-207">
                    Extra energi för ökad uthållighet hela natten
                  </p>
                </div>
                <div className="p-3 bg-gray-800 rounded-md mt-4" data-id="element-208">
                  <p className="text-sm font-medium text-white mb-1" data-id="element-209">
                    VeeloBooster har noga testats i laboratorium.
                  </p>
                  <p className="text-xs text-gray-300" data-id="element-210">
                    Vårt program är säkert, vetenskapligt bevisat och godkänt av
                    experter.
                  </p>
                </div>
              </div>
              <div className="space-y-3" data-id="element-211">
                <a href="https://www.fasttrack39.com/Q2F67GN8/2K64K71K/" className="block w-full py-3 bg-[#0EB7FF] hover:bg-[#0EA7EF] text-black font-semibold rounded-md text-center transition-all" data-id="element-212">
                  Prova VeeloBooster nu
                </a>
                <p className="text-center text-sm text-[#10C96C] font-medium" data-id="element-213">
                  Nöjdhet garanteras!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 p-4 bg-gray-800 rounded-lg flex items-start" data-id="element-214">
          <div className="mr-3 mt-1" data-id="element-215">
            <InfoIcon className="w-5 h-5 text-[#0EB7FF]" data-id="element-216" />
          </div>
          <div className="text-sm text-gray-300" data-id="element-217">
            <p className="font-medium mb-1" data-id="element-218">VeeloBooster:s formel:</p>
            <p data-id="element-219">
              VeeloBooster:s formel är skapad enbart av naturliga ingredienser
              som använts i tusentals år för att bekämpa impotens, öka libidot,
              energin, stämningen och den sexeuella njutningen. Alla
              ingredienser är kliniskt bevvisade i laboratorium.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ProductSection;